export const
  babyblue= '#599BA4',
  flagred = '#CF0207',
  greenishblue = '#012126',
  quickblue = '#01788A';
